import { loadable } from '@change/core/react/loadable';

import type { AppRoute } from 'src/shared/routes';

import { Loading } from 'src/app/shared/routes';

export const ROUTES: readonly AppRoute[] = [
	{
		id: 'psf-start-a-local-petition',
		path: '/p/:slug/psf/start-a-local-petition',
		component: loadable(async () => import(/* webpackChunkName: "pages/psf_start_a_local_petition" */ './index'), {
			exportName: 'StartALocalPetition',
			fallback: Loading,
		}),
		frame: { footer: false, header: true },
		ssr: {
			// switch this to true to enable SSR
			enabled: true,
			seo: false,
		},
	},
];
